export default "__VITE_ASSET__Qti6nAI5__"